import { cn } from '@repo/lib/cn';
import { questionMatchingSchema } from '@repo/schemas/quiz/questionMatching';
import { CircleAlertIcon, PlusIcon } from 'lucide-react';

import { QuestionContentFormField, QuestionMatchingAnswerFieldset } from '@/components/features/quiz/question/question-builder';
import { Button } from '@/components/ui/button';
import { ErrorMessage, Form } from '@/components/ui/form';
import { useQuestionMatchingForm } from '@/hooks/questions';
import { questionsLabel } from '@/lib/questions-labels';
import { formErrorToast } from '@/utils/form';

import type { QuestionMatchingFormProps } from '.';

export function QuestionMatchingForm(questionMatchingFormProps: QuestionMatchingFormProps) {
  const { data, onSubmit = () => {}, className, ...props } = questionMatchingFormProps;

  const { form, matchingQuestionAnswers, handleAddAnswer, handleRemoveAnswer } = useQuestionMatchingForm(data);

  return (
    <Form {...form}>
      <form {...props} noValidate onSubmit={form.handleSubmit(onSubmit, () => formErrorToast(form, questionMatchingSchema))} className={cn('h-full', className)}>
        <div className="divide-border-primary divide-y">
          <QuestionContentFormField />
          <div className="space-y-6 p-3">
            <div className="text-muted-foreground flex items-center gap-1 text-xs">
              <CircleAlertIcon className="size-4" />
              <p>{data?.type && questionsLabel[data.type].builderDesc}</p>
            </div>
            <ErrorMessage className="my-4 min-h-0 w-full" name={'answers.root'} />
            <div className="flex flex-col items-stretch gap-3 xl:flex-row">
              {matchingQuestionAnswers.fields.map((field, index) => (
                <div key={field.id} className="w-full xl:min-w-0 xl:flex-1">
                  <QuestionMatchingAnswerFieldset form={form} index={index} removeAnswer={handleRemoveAnswer} canRemove={matchingQuestionAnswers.fields.length > 2} />
                </div>
              ))}
              <Button
                type="button"
                variant={'outline'}
                size={'sm'}
                className={cn('border-dashed w-full xl:w-auto xl:my-auto', matchingQuestionAnswers.fields.length === 5 && 'hidden')}
                onClick={handleAddAnswer}
              >
                <PlusIcon />
                <span className="block xl:hidden">Dodaj odpowiedź</span>
              </Button>
            </div>
          </div>
        </div>
      </form>
    </Form>
  );
}
